import { withSuperJSONProps as _withSuperJSONProps, withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import React from "react";
import Link from "next/link";
import HeadLine from "../../../../../components/headLine";
import Meta from "../../../../../components/Meta";
import prisma from '../../../../../prisma/prisma';
import EntityMappingService from '../../../../../services/entity-mapping-service';
import RiderProfilePhoto from '../../../../../components/rider-profile-photo';
export const getServerSideProps = _withSuperJSONProps(async context => {
  const {
    id
  } = context.params;
  const facility$ = await prisma.trainingFacility.findFirst({
    where: {
      id
    },
    include: {
      Riders: true
    }
  });
  if (!facility$) {
    return {
      notFound: true
    };
  }
  const numberOfRiders = facility$.Riders.length ?? 0;
  const riderNames = facility$.Riders.map(x => x.riderName.toLowerCase());
  const riderIdRecords = await prisma.riderId.findMany({
    where: {
      name: {
        in: riderNames
      }
    }
  });
  const riderIds = riderIdRecords.map(x => x.id);
  const podiums = await prisma.raceEventClassResult.count({
    where: {
      AND: [{
        OR: [{
          finishingPosition: '1st'
        }, {
          finishingPosition: '2nd'
        }, {
          finishingPosition: '3rd'
        }]
      }, {
        riderId: {
          in: riderIds
        }
      }]
    }
  });
  const overalls = await prisma.raceEventClassResult.count({
    where: {
      AND: [{
        finishingPosition: '1st'
      }, {
        riderId: {
          in: riderIds
        }
      }]
    }
  });
  const details = [{
    id: '1`',
    detailsNumber: numberOfRiders,
    detailsText: 'Riders'
  }, {
    id: '2',
    detailsNumber: podiums,
    detailsText: 'Podiums'
  }, {
    id: '3',
    detailsNumber: overalls,
    detailsText: 'Overalls'
  }, {
    id: '4',
    detailsNumber: facility$.isFeatured ? 'Yes' : 'No',
    detailsText: 'Feautured?'
  }];
  const facility = EntityMappingService.mapTrainingFacility(facility$);
  const riders = facility.Riders ?? [];
  return {
    props: {
      facility,
      details,
      riders
    }
  };
}, []);
const FacilityDetailPage = ({
  facility,
  details,
  riders
}) => {
  const {
    id,
    profilePicUrl,
    title,
    trainers,
    url,
    city,
    state,
    description,
    isFeatured
  } = facility;
  return <>
      <Meta title={`AmateurMoto.com | ${title}`} data-sentry-element="Meta" data-sentry-source-file="index.jsx" />
      <div className="pt-[5.5rem] lg:pt-24 bg-white">
        <div className="relative h-[18.75rem]">
          <img width={1519} height={300} src={profilePicUrl} alt={title} className="w-full h-full object-cover" />
        </div>
        <section className="dark:bg-jacarta-800 bg-light-base relative pb-12 pt-28">
          <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
            <figure className="relative h-40 bg-white w-40 rounded-xl border-[5px] border-black">
              <img width={141} height={141} src={profilePicUrl} alt={title} className="dark:border-jacarta-600 rounded-xl border-[5px] border-white w-full h-full object-contain" />
            </figure>
          </div>

          <div className="container">
            <div className="text-center">
              <h2 className="font-display text-jacarta-700 mb-2 text-4xl font-medium dark:text-white">
                {title}
              </h2>
              <div className="dark:bg-jacarta-800 dark:border-jacarta-600 border-jacarta-100 mb-8 inline-flex flex-wrap items-center justify-center rounded-xl border bg-white">
                {details.map(({
                id,
                detailsNumber,
                detailsText
              }) => {
                return <Link href={`/apps/training-facilities/detail/${id}`} key={id} className="dark:border-jacarta-600 border-jacarta-100 w-1/2 rounded-l-xl border-r py-4 hover:shadow-md sm:w-32">
                      <div className="text-jacarta-700 mb-1 text-base font-bold dark:text-white">
                        {detailsNumber}
                      </div>
                      <div className="text-2xs dark:text-jacarta-400 font-medium tracking-tight">
                        {detailsText}
                      </div>
                    </Link>;
              })}
              </div>
              <p className="dark:text-jacarta-300 mx-auto mb-2 max-w-xl text-lg">
                {description}
              </p>
              <Link href={url} data-sentry-element="Link" data-sentry-source-file="index.jsx">
                <button className="border py-2 px-4 inline-block rounded-full font-semibold transition-all mt-4">
                  View {title}'s instagram
                </button>
              </Link>
            </div>
          </div>
        </section>
        <section className="relative py-12">
          <div className="container">
            <HeadLine text="Riders" classes="font-display text-jacarta-700 text-center text-3xl dark:text-white mb-6" data-sentry-element="HeadLine" data-sentry-source-file="index.jsx" />
            {!riders.length && <>
                <p className="text-center font-semibold">{title} doesn't have any riders yet, if you train with {title} you can <a href="/my-profile" className="text-accent">update your profile</a>.</p>
              </>}
            <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4">
              {riders.map(rider => <article key={`${rider.riderName}`}>
                  <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                    <figure className="relative">
                      <Link href={`/rider/${rider.riderName}`}>
                        <RiderProfilePhoto url={rider.profilePicUrl} height={160} />
                      </Link>
                    </figure>
                    <div className="mt-7 flex items-center justify-between">
                      <Link href={`/rider/${rider.riderName}`}>
                        <span className="font-display text-jacarta-700 hover:text-accent text-base dark:text-white">
                          {rider.riderName}
                        </span>
                      </Link>
                    </div>

                    <div className="mt-8 flex items-center justify-between">
                      <Link href={`/rider/${rider.riderName}`} className="group flex items-center">
                        <svg className="icon icon-history group-hover:fill-accent dark:fill-jacarta-200 fill-jacarta-500 mr-1 mb-[3px] h-4 w-4">
                          <use xlinkHref="/icons.svg#icon-history"></use>
                        </svg>
                        <span className="group-hover:text-accent font-display dark:text-jacarta-200 text-sm font-semibold">
                          View Profile
                        </span>
                      </Link>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </section>
      </div>
    </>;
};
export default _withSuperJSONPage(FacilityDetailPage);